import * as THREE from "three";

export const roundVector = function (vector) {
  return new THREE.Vector3(
    parseFloat(vector.x.toFixed(6)),
    parseFloat(vector.y.toFixed(6)),
    parseFloat(vector.z.toFixed(6))
  );
};
